export default __webpack_public_path__ + "static/pole-3-img-e7210fc66ca8e465d20b7d4462ac337e.png";